<template>
    <m-basetabs :route-name="routerName" :route-param="routeParam" :active="active" @update:active="val => $emit('update:active', val)">
        <template v-slot:tabs="{tabs}">
            <ul class="bg-gray-300 rounded-t-md" ref="ul">
                <li class="inline-block text-black ml-2 text-center p-2 mt-1 cursor-pointer text-base rounded-t-md"
                    v-for="(tab, index) in tabs"
                    :class="active == index ? ['bg-primary-600', 'text-white'] : ['bg-gray-300', 'hover_bg-gray-400']"
                    ref="tablist" @click="$emit('update:active', index)">
                    <m-ripple class="p-2" color="#000">
                        <slot name="tab" :text="tab.text">{{ tab.text }}</slot>
                    </m-ripple>
                </li>
            </ul>
        </template>
        <div class="p-4 bg-gray-100 border">
            <slot></slot>
        </div>
    </m-basetabs>
</template>

<script>
import BaseTabs from '../basecomponents/tabs.vue'

export default {
    components: {
        'm-basetabs': BaseTabs
    },
    props: {
        active: Number,
        routeParam: String,
        routerName: String
    },
    name: 'secondary-tabs'
}
</script>
